
export default function() {

  const addErrorAlert = () => {
    let dls = document.querySelectorAll('dl');
    if (dls && dls.length>0){
      for (var i = 0; i<dls.length; i++) {
        if (dls[i].querySelector('dd span.error')){
          dls[i].classList.add('error');
        }
      }
    }
  }
  const contactPageElement = document.querySelector('.p-contact__progress--top')
  if(contactPageElement) {
    addErrorAlert();
  }
}